import {
  clearSafeInterval,
  clearSafeTimeout,
  scheduleSafeInterval,
  scheduleSafeTimeout,
} from './browserTimers';

const pendingTimersFor = (component) => {
  if (!component.pendingTimers) {
    component.pendingTimers = new Set();
  }
  return component.pendingTimers;
};

const pendingIntervalsFor = (component) => {
  if (!component.pendingIntervals) {
    component.pendingIntervals = new Set();
  }
  return component.pendingIntervals;
};

export const scheduleComponentTimer = (component, callback, delay) => {
  const pendingTimers = pendingTimersFor(component);
  const timer = scheduleSafeTimeout(() => {
    pendingTimers.delete(timer);
    if (component.isComponentDestroyed) {
      return;
    }
    callback();
  }, delay);

  if (timer) {
    pendingTimers.add(timer);
  }
  return timer;
};

export const scheduleComponentInterval = (component, callback, delay) => {
  const pendingIntervals = pendingIntervalsFor(component);
  const interval = scheduleSafeInterval(() => {
    if (component.isComponentDestroyed) {
      return;
    }
    callback();
  }, delay);

  if (interval) {
    pendingIntervals.add(interval);
  }
  return interval;
};

export const clearComponentTimer = (component, timer) => {
  if (!timer) {
    return;
  }

  clearSafeTimeout(timer);
  pendingTimersFor(component).delete(timer);
};

export const clearComponentInterval = (component, interval) => {
  if (!interval) {
    return;
  }

  clearSafeInterval(interval);
  pendingIntervalsFor(component).delete(interval);
};

export const clearComponentTimers = (component) => {
  const pendingTimers = pendingTimersFor(component);
  pendingTimers.forEach((timer) => {
    clearSafeTimeout(timer);
  });
  pendingTimers.clear();

  const pendingIntervals = pendingIntervalsFor(component);
  pendingIntervals.forEach((interval) => {
    clearSafeInterval(interval);
  });
  pendingIntervals.clear();
};
